<div class="loader-container">
  <div>
    <svg id="check" [ngClass]=" isProcessing ? 'progress' : 'ready'" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" xml:space="preserve">
      <circle id="circle" cx="50" cy="50" r="46" fill="transparent" />
      <polyline id="tick" points="25,55 45,70 75,33" fill="transparent" />
    </svg>
    <ng-container *ngIf="isProcessing; else successLoader">
      <p>{{'processing-order'| translate }}</p>
    </ng-container>
    <ng-template #successLoader>
      <p>{{'order-processed'| translate}}</p>
    </ng-template>
  </div>
</div>
